<template>
  <div class="bottom-border">
    <h3 class="d-flex align-items-center py-3 mb-0 mt-0 title-bar bottom-border">
      <AdditionalExplanation
        class="ms-3 text-size"
        :text="trans('subscription.group_config.group_config_explanation')"
      >
        <span
          class="fa fa-info-circle"
        />
      </AdditionalExplanation>
      {{ trans('subscription.group_config.group_config') }}
    </h3>
    <div class="d-flex flex-wrap">
      <template
        v-for="(group, groupIndex) in groups"
      >
        <GroupConfig
          :key="groupIndex"
          v-model="groups[groupIndex]"
          :group-name="groupIndex"
          :is-loading="isLoading"
          :selector-context="groupsSelectorContext"
          @Remove="remove"
          @Update="update"
          @Copy="copy"
        />
      </template>
    </div>
    <div class="d-flex flex-row-reverse my-1 p-2">
      <Modal
        v-if="selected !== null"
        :open="true"
        :title="trans('subscription.classification_config.group_modal.new_group')"
        @close="closeModal()"
      >
        <GroupConfigEditView
          :is-loading="isLoading"
          :selector-context="groupsSelectorContext"
          @Save="save"
        />
      </Modal>
      <button
        type="button"
        class="btn btn-primary mx-3"
        :disabled="isLoading"
        @click="select()"
      >
        {{ trans('subscription.group_config.add_group_config') }}
      </button>
    </div>
  </div>
</template>

<script>
import { selectorUpdateSelectorGroup } from '@/employees/components/Selector/utilities/builder/selectorBuilder'
import toast from '@/services/toast'
import Modal from '@/employees/AttendanceList/components/Modal'
import GroupConfig from '@/employees/components/GroupConfig/GroupConfig'
import AdditionalExplanation from '@/employees/components/AdditionalExplanation'
import GroupConfigEditView from '@/employees/components/GroupConfig/GroupConfigEditView'
export default {
  name: 'GroupConfigList',
  components: {
    AdditionalExplanation,
    GroupConfig,
    Modal,
    GroupConfigEditView,
  },
  provide () {
    return {
      programId: this.programId,
    }
  },
  props: {
    value: {
      required: false,
      type: [String, Object],
      default: null,
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false,
    },
    emitObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectorContext: {
      required: false,
      type: Object,
      default: null,
    },
    programId: {
      required: true,
      type: [Number, String],
    },
  },
  data () {
    return {
      groups: null,
      selected: null,
      groupsSelectorContext: null,
    }
  },
  watch: {
    groups: {
      deep: true,
      handler (newValue) {
        if (newValue) {
          const groups = newValue
          this.$emit('input', groups)
        }
      },
    },
    selectorContext: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          this.groupsSelectorContext = newValue
        }
      },
    },
  },
  created () {
    if (this.value != null) {
      if (typeof this.value === 'string' || this.value instanceof String) {
        this.groups = JSON.parse(this.value)
      } else {
        this.groups = this.value
      }
    } else {
      this.groups = {}
    }
    this.$root.$on('ConfigGroupUpdate', this.configGroupUpdate)
  },
  destory () {
    this.$root.$off('ConfigGroupUpdate', this.configGroupUpdate)
  },
  methods: {
    save ({ name, term, max, selector }) {
      this.$set(this.groups, name, { term, max, selector })
      this.selected = null
    },
    remove (name) {
      this.$delete(this.groups, name)
    },
    update ({ currentGroupName, newGroupName, term, max, selector }) {
      if (this.groups) {
        const newGroups = {}
        for (const [key, value] of Object.entries(this.groups)) {
          if (key === currentGroupName) {
            newGroups[newGroupName] = { term, max, selector }
          } else {
            newGroups[key] = value
          }
        }
        this.groups = newGroups
      }
    },
    copy ({ name, max, selector }) {
      this.$set(this.groups, name, { max, selector })
      toast.info(Lang.trans('subscription.classification_config.group_copy'))
    },
    select () {
      this.selected = true
    },
    closeModal () {
      this.selected = null
    },
    // #region Update selector using old config name
    configGroupUpdate ({ oldName, newName }) {
      if (oldName !== newName) {
        for (const group of Object.values(this.groups)) {
          if (group.selector) {
            selectorUpdateSelectorGroup(group.selector, oldName, newName)
          }
        }
      }
    },
    // #endregion
  },
}
</script>

<style scoped>
.title-bar {
  background-color: rgba(0, 0, 0, 0.06);
  width: 100%;
}
.bottom-border{
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
}
/deep/
.btn-warning{
  background: #FFC30E !important;
  color: white !important;
}
</style>
